<div class="root">
    <span class="expander" (click)="toggleExpanded()">
        {{isExpanded ? 'V' : '>'}}
    </span> <b>{{index}}. {{phoneCall.callId || "Unknown Call Id"}}</b> : {{phoneCall.callType}}, {{phoneCall.state}}{{isCallHeld() ? ' (Held)' : ' (Unheld)'}}, {{phoneCall.contact.id}}
    <div class="details" *ngIf="isExpanded">
        <ul>
            <li>callId: {{phoneCall.callId}}</li>
            <li>callType: {{phoneCall.callType}}</li>
            <li>
                <span class="expander" (click)="toggleContactExpanded()">
                    {{isContactDetailsExpanded ? 'V' : '>'}}
                </span>
                <span>
                    &nbsp;contact: <b>{{phoneCall.contact.id}}</b>
                </span>
                <app-active-call-contact-details [contact]="phoneCall.contact" *ngIf="isContactDetailsExpanded"></app-active-call-contact-details>
            </li>
            <li>state: {{phoneCall.state}}</li>
            <li>
                <span class="expander" (click)="toggleAttributesExpanded()">
                    {{isAttributesExpanded ? 'V': '>'}}
                </span>
                <span>
                    &nbsp;callAttributes:
                </span>
                <app-active-call-attributes [attributes]="phoneCall.callAttributes" *ngIf="isAttributesExpanded"></app-active-call-attributes>
            </li>
            <li>phoneNumber: {{phoneCall.phoneNumber}}</li>
            <li>
                <span class="expander" (click)="toggleInfoExpanded()">
                    {{isInfoExpanded ? 'V': '>'}}
                </span>
                <span>
                    &nbsp;callInfo:
                </span>
                <app-active-call-info [callInfo]="phoneCall.callInfo" *ngIf="isInfoExpanded"></app-active-call-info>
            </li>
            <li>reason: {{phoneCall.reason}}</li>
            <li>closeCallOnError: {{phoneCall.closeCallOnError}}</li>
            <li>agentStatus: {{phoneCall.agentStatus}}</li>
            <li>agentARN: {{phoneCall.agentARN}}</li>
        </ul>
    </div>
</div>
